<template>
  <div style="margin-top: 25px;">
    <b-carousel
      :ref="slideId"
      :id="slideId"
      v-model="slide"
      :interval="interval"
      :controls="controls"
      :indicators="indicators"
      background="#FFFFFF"
      :img-height="viewHeight"
      style=""
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
      no-touch="true"
    >
      <b-carousel-slide
        v-for="(anAudio, i) in playListJSON"
        :name="anAudio.name"
        :key="i"
      >
        <template #img>
          <audio-row :audio="anAudio" :assets-url-home="assetsURLHome" />
        </template>
      </b-carousel-slide>
    </b-carousel>
    <p v-if="false" class="mt-4">
      Slide #: {{ slide }}<br />
      Sliding: {{ sliding }}
    </p>
    <resource-nav-bar
      v-if="resource"
      :resource="resource"
      :assets-url-home="assetsURLHome"
      @open-about="handleAboutClick"
      @open-playlist="handleShowPlayList"
    />
    <b-sidebar
      :id="sidebarId"
      :visible="sidebarModel"
      sidebar-class="border-right border-danger"
      right
      shadow
      lazy
    >
      <b-card
        v-for="(anAudio, i) in playListJSON"
        :title="anAudio.title"
        :img-src="`${assetsURLHome}${anAudio.imgURL}`"
        img-alt="Image"
        img-left
        @click="handlePlayInd(i)"
        :key="`pl-${i}`"
        img-height="75px"
        img-width="75px"
        style="cursor: pointer; vert-align: middle"
      >
        <b-card-text>
          {{ anAudio.artist }}
        </b-card-text>
      </b-card>
      <template #footer>
        <div class="d-flex bg-dark text-light align-items-center px-3 py-2">
          <strong class="mr-auto">Last updated today</strong>
          <b-button size="sm" @click="handleCloseSideBar">Close</b-button>
        </div>
      </template>
      <div></div>
    </b-sidebar>
  </div>
</template>

<script>
import ResourceBlockDisplay from "@/mixins/resourceBlocks/Display";
import AudioRow from "./audioRow";
import ResourceNavBar from "./resourceNavBar";
import playListJSON from "../../assets/json/playList.json";
export default {
  name: "Display_PlayList",
  mixins: [ResourceBlockDisplay],
  components: {
    AudioRow,
    ResourceNavBar
  },
  props: {},
  created() {
    //this.playRepeat();
  },
  mounted() {},
  computed: {
    /* SETTINGS */
    settings_showProgressStats() {
      const _default = true;
      return this.settings && this.settings.user
        ? this.settings.user.isDisplayStats
        : _default;
    }
  },
  methods: {
    playRepeat() {
      if (this.playInd < this.playListJSON.length) {
        //Just in case a new one is added or deleted during play
        const audioURL = `${this.assetsURLHome}${
          this.playListJSON[this.playInd].audioURL
        }`;
        this.player = new Audio(audioURL);

        let that = this; // Check that there are no issues with this
        this.player.addEventListener("ended", function() {
          that.player.currentTimer = 0;
          that.playInd++; //If shuffle- then randomize
          that.handleGoToSlideAudioWith(that.playInd);
          that.playRepeat();
        });
        //this.audioDuration = this.getDuration(this.player.duration);
        if (this.player) {
          this.player.play();
        }
      } else {
        this.playInd = 0;
      }
    },
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
    handleOpenSideBar() {
      this.sidebarModel = true;
    },
    handleCloseSideBar() {
      this.sidebarModel = false;
    },
    handleGoToSlideAudioWith(audioInd) {
      this.$refs[this.slideId].setSlide(audioInd);
    },
    handleShowPlayList() {
      this.handleOpenSideBar();
    },
    handlePlayInd(ind) {
      this.playInd = ind;
      this.player.pause();
      this.handleGoToSlideAudioWith(this.playInd);
      this.handleCloseSideBar();
      this.playRepeat();
    }
  },
  data() {
    return {
      playListJSON,
      assetsURLHome: "/assets/apps/playlist/",
      audioDuration: null,
      sidebarId: "playlist-sidebar",
      sidebarModel: false,
      /* SLIDE INFO*/
      viewHeight: 250,
      slideId: "audioSlides",
      interval: 0,
      controls: false,
      indicators: false,
      slide: 0,
      sliding: null,
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 75,
        height: 75,
        class: "m1"
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
